import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from './CartDrawer';
export function ShopLayout() {
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-300" data-mp="25e4bfml9t8hj">
      <Header data-id="element-301" data-mp="25ct6hjg39uou" />
      <main className="flex-1" data-id="element-302" data-mp="2adgv5yguhzfw">
        <Outlet data-id="element-303" data-mp="2acnyjqbloqbh" />
      </main>
      <Footer data-id="element-304" data-mp="2acxndakwsrfl" />
      <CartDrawer data-id="element-305" data-mp="2abcudpe8tgju" />
    </div>;
}